<template>
    <modal :class="{'is-active':isModalActive}" :onClose="close">
        <header slot="header" class="modal-card-head has-text-centered">
            <p class="modal-card-title">{{"components.common.modals.logout.title" | translate}}</p>
            <button class="delete" aria-label="close" @click="close()"></button>
        </header>
        <section slot="content" class="modal-card-body">
            <p class="title is-4 has-text-centered">{{"components.common.modals.logout.confirmation message" | translate}}</p>
            <div class="field has-text-centered">
                <button
                    slot="footer"
                    class="button is-danger is-medium"
                    @click="logout()"
                >{{"components.common.modals.logout.yes" | translate}}</button>
                <button
                    slot="footer"
                    class="button is-success is-medium"
                    @click="close()"
                >{{"components.common.modals.logout.no" | translate}}</button>
            </div>
        </section>
    </modal>
</template>
<script>
import Vue from 'vue';

import authService from '../../../../../../_common/services/authentication.service';

import Modal from '../modal.vue';

export default {
    name: 'logout',
    components: { Modal },
    computed: {
        isModalActive() {
            return Vue.state.modals.logout.isActive();
        }
    },
    methods: {
        close() {
            Vue.state.modals.logout.close(new Error('closed'));
        },
        async logout() {
            await Vue.state.player.logout();
            Vue.state.modals.logout.close();
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/modals/logout/logout.vue